export const coachQuestions = [
  'What am I going to teach tomorrow?',
  'Which drill should I use?',
  'How should I structure the session?',
  'What happens if the rider struggles?',
  'Which cue should I give?',
  'Should I regress the skill?',
  'Are they ready to progress?',
]

export const painCosts = [
  'Hours lost every week searching for drills and session ideas',
  'Repeating the same exercises because they are the ones you already know',
  'Improvising in front of riders when your original plan stops working',
  'Seeing technical errors without immediately knowing which correction or drill should come next',
  'Riders attending session after session without a clear progression',
  'Difficulty adapting when one rider progresses faster than another',
  'Lessons that feel disconnected instead of part of a complete development pathway',
  'Evenings and weekends spent planning instead of riding, resting or growing your coaching business',
]
